// extracted by mini-css-extract-plugin
export var dropdownIcon = "_mr-6";
export var imgContainer = "_mr-3";
export var menuIcon = "_mr-5";
export var pillWrapper = "_mr-2";
export var pillsContainer = "_mr-1";
export var subscriptionCard = "_mr-0";
export var subscriptionLogo = "_mr-4";